
import { Dialog, DialogContent, IconButton, makeStyles, Slide, Typography } from "@material-ui/core"
import React from "react"
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import CloseIcon from '@material-ui/icons/Close';
import { CreateNewPoll } from "./CreatePoll/formCreatePoll";
import { EditPoll } from "./EditPoll/formEditPoll";
import theme from "../../app/config/themaConfig";

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="down" ref={ref} {...props} />;
});

//My style
const useStyles = makeStyles((theme) => ({
    modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },

    root: {
        margin: 0,
        padding: theme.spacing(2)
    },
    closeButton: {
        position: "absolute",
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500]
    },

}));

const DialogTitle = ((props) => {
    const classes = useStyles();
    const { children, onClose, ...other } = props;
    return (
        <MuiDialogTitle disableTypography className={classes.root} {...other}>
            <Typography variant="h6" style={{ textAlign: "center" }}>{children}</Typography>
            {onClose ? (
                <IconButton
                    aria-label="close"
                    className={classes.closeButton}
                    onClick={onClose}
                >
                    <CloseIcon />
                </IconButton>
            ) : null}
        </MuiDialogTitle>
    );
});

export default function ModalPolls({ setopenMondal, isOpen, dataEdit, setdataEdit, isEdit, createNewPoll, editPoll }) {

    const clearData = () => {
        setopenMondal(false)
        setdataEdit({})
    }
    const primaryColor = theme.palette.primary.main;

    return (
        <div>
            <Dialog
                onClose={(e) => { clearData() }}
                aria-labelledby="customized-dialog-title"
                open={isOpen}
                TransitionComponent={Transition}
                keepMounted
                style={{ maxHeight: "500%" }}
                fullWidth={true}
                maxWidth="xs"
            >
                <DialogTitle id="customized-dialog-title" onClose={(e) => { clearData() }} style={{color:primaryColor}} >
                    {isEdit? "Editar encuesta": "Crear Encuesta"}
                </DialogTitle>
                <DialogContent style={{ paddingBottom: '30px' }}>
                    {isEdit ?
                        (
                            <EditPoll dataEdit={dataEdit} editPoll={editPoll} />
                        )
                        :
                        (
                            <CreateNewPoll create={createNewPoll} />
                        )

                    }

                </DialogContent>
            </Dialog>
        </div>
    )
}